import { render } from "./JWaitCheck.vue?vue&type=template&id=804f5ce8&scoped=true&ts=true"
import script from "./JWaitCheck.vue?vue&type=script&lang=ts"
export * from "./JWaitCheck.vue?vue&type=script&lang=ts"

import "./JWaitCheck.vue?vue&type=style&index=0&id=804f5ce8&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804f5ce8"]])

export default __exports__